import { Pipe, PipeTransform } from '@angular/core';
import { ECommerceSubTenant } from '@pdqdev/pdq-shared/dist/entities';
import { DropdownOption } from '../../../storybook/components/dropdown/dropdown.component';

@Pipe({
  name: 'eCommerceSubTenantsOptions',
  standalone: false,
})
export class eCommerceSubTenantsOptionsPipe implements PipeTransform {
  transform(subTenants: ECommerceSubTenant[], activeSubTenants: ECommerceSubTenant[]): DropdownOption[] {
    if (!subTenants?.length) {
      return [];
    }

    const res = subTenants.map((subTenant) => {
      return {
        value: subTenant.id,
        label: subTenant.name,
        checked: activeSubTenants?.some((activeSubTenant) => activeSubTenant.id === subTenant.id),
      };
    });
    return res;
  }
}
